import styled from 'styled-components'
import { v1 as color, media } from 'sidecar-design-library'

export const InputSelectGroupOption = styled.div`
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;

  ${p =>
    p.heading &&
    `
    color: ${color.BLACK};
    background-color: ${color.SMOKE};
    margin-left: -1.25rem;
    padding-left: 1.25rem;
    font-family: sidecarta-sans-bold;
    border-top: 1px solid ${color.SILVER};
  `}

  ${p =>
    p.subLabel &&
    `
    padding-left: 1.25rem;
    line-height: 1.5;
  `}
`

export const InputSelectReadOnly = styled.div`
  min-height: 3.125rem;
  width: 100%;
  position: relative;
  border: 1px solid ${color.SILVER};

  div:nth-child(1) {
    color: #0E60C9;
    background: white;
    position: absolute;
    top: -0.625rem;
    left: 0.625rem;
    font-size: 1.0625rem;
    padding: 0px 5px;
  }

  div:nth-child(2) {
    position: absolute;
    top: 0.9375rem;
    left: 0.9375rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    padding: 0px 0px 0px 5px;
    color: ${color.CHARCOAL};

    ${media.tabletAndBelow`
      width: 80%;
    `}
`
